<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <b-card v-for="order in orders" :key="order.id" :title="'Заказ ' + orderTypes[order.type]">
                    <p>Контрагент: {{ order.counterpart }}</p>
                    <p>Дата заказа: {{ order.date }}</p>
                    <p>Сумма заказа: {{ order.amount.amount }} <small>{{ order.amount.currency }}</small></p>
                    <div slot="footer">
                        <b-btn variant="primary" @click="setOrderPaid(order.id)">Оплачен</b-btn>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    export default {
        name: 'AdminOrdersList',
        data () {
            return {
                orders: [],
                orderTypes: {
                    deposit: 'на депозит',
                    franchise: 'на франшизу'
                }
            }
        },
        mounted () {
            this.loadOrdersList()
        },
        methods: {
            loadOrdersList () {
                this.axios.get('admin/orders').then(response => {
                    console.log(response.data)
                    this.orders = response.data.orders
                })
            },
            setOrderPaid (orderId) {
                this.axios.post('admin/orders/paid', {
                    order: orderId
                }).then(response => {
                    console.log(response.data)
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Orders.vue?2a1f9512